import React from "react";
import { Link } from "react-router-dom";
import "./Item.css";
import { CUSTOM_BLOUSE_PRICE } from "../../pages/CustomizeBlouse";
import { formatPrice } from "../../utils/formatPrice";

const frontDesignFiles = require.context("../assets/tailor/blouse/designs/blouse-front", false, /\.(png|jpe?g)$/i);
const frontPreview = frontDesignFiles(frontDesignFiles.keys().sort()[0]);

// Not a real Firestore product - a static entry point into the pick-your-own
// front/back design flow at /tailor/design-your-blouse.
const CustomizeBlouseItem = () => (
    <div>
        <div className="item">
            <div className="item-link">
                <Link to="/tailor/design-your-blouse"><img src={frontPreview} alt="Design your blouse" /></Link>
            </div>
            <p>Design Yours</p>
            <div className="item-prices-container">
                <div className="item-prices">
                    <div className="item-price-new">Starting at {formatPrice(CUSTOM_BLOUSE_PRICE)}</div>
                </div>
                <Link to="/tailor/design-your-blouse" className="cafe-button">
                    <span>DESIGN YOURS</span>
                </Link>
            </div>
        </div>
    </div>
);

export default CustomizeBlouseItem;
